import { ReactComponent as Discord } from "assets/img/icons/discordDark.svg";
import { ReactComponent as Docs } from "assets/img/icons/doccss.svg";
import { ReactComponent as Medium } from "assets/img/icons/mediumDark.svg";
import { ReactComponent as Telegram } from "assets/img/icons/tgDark.svg";
import { ReactComponent as Website } from "assets/img/icons/world.svg";
import { ReactComponent as Twitter } from "assets/img/icons/xDark.svg";
import { ReactComponent as Youtube } from "assets/img/icons/youtube.svg";
import { FC } from "react";
import styles from "./social-icons.module.scss";

export interface SocialLinkItem {
  label: string;
  value: string;
}

interface SocialIconsProps {
  links: SocialLinkItem[] | Record<string, string>;
  isDashboard?: boolean;
}

const SocialIcons: FC<SocialIconsProps> = ({ links = [], isDashboard }) => {
  const safeLinks: SocialLinkItem[] = Array.isArray(links)
    ? links
    : Object.entries(links)
        .filter(([key, value]) => value && value.trim() !== "")
        .map(([key, value]) => ({ label: key, value }));

  const renderIcon = (label: string) => {
    switch (label.toLowerCase()) {
      case "discord":
        return <Discord />;
      case "medium":
        return <Medium />;
      case "memolink":
        return <Docs />;
      case "telegram":
        return <Telegram />;
      case "twitter":
        return <Twitter />;
      case "website":
        return <Website />;
      case "youtube":
        return <Youtube />;
      default:
        return null;
    }
  };

  return (
    <div
      className={`${styles.socialIcons} ${
        isDashboard ? styles.dashboardIcons : ""
      }`}
    >
      {safeLinks.map((link) =>
        link.value ? (
          <a
            key={link.label}
            href={link.value}
            target="_blank"
            rel="noopener noreferrer"
          >
            {renderIcon(link.label) || link.label}
          </a>
        ) : null
      )}
    </div>
  );
};

export default SocialIcons;
